<cng-layout-legacy id="history" [menuRef]="menu" [mainRef]="main"></cng-layout-legacy>

<!-- Menu template -->
<ng-template #menu>
  <ul>
    <li>
      <a
        [routerLink]="[HistoryState.CONTACT]"
        routerLinkActive
        #contactRla="routerLinkActive"
        [active]="contactRla.isActive"
        [disabled]="contactRla.isActive"
        [ngClass]="{ current: contactRla.isActive }"
      >
        {{ 'history:viewContacts.title' | translate }}
      </a>
    </li>
    <li>
      <a
        [routerLink]="[HistoryState.INTERACTION]"
        routerLinkActive
        #interactionRla="routerLinkActive"
        [active]="interactionRla.isActive"
        [disabled]="interactionRla.isActive"
        [ngClass]="{ current: interactionRla.isActive }"
      >
        {{ 'history:viewInteractions.title' | translate }}
      </a>
    </li>
  </ul>
</ng-template>
<!-- Main template -->
<ng-template #main>
  <router-outlet></router-outlet>
</ng-template>
